import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";
import { Workbook } from "exceljs";
import { roles } from "../../../../common/constants";
/**
 *
 * @param {any[]} topCustomers
 * @param {any[]} topCustomersCompare
 * @returns {Workbook}
 */
export const exportExcel = async (
  topCustomers,
  topCustomersCompare,
  selectedStore,
  selectedStoreCompare,
  startDate,
  endDate,
  role
) => {
  const columns = {
    props: [
      {
        inValue: "name",
        outValue: "NOMBRES",
      },
      {
        inValue: "lastname",
        outValue: "APELLIDOS",
      },
      {
        inValue: "email",
        outValue: "CORREO ELECTRONICO",
      },
      {
        inValue: "totalbought",
        outValue: "MONTO GASTADO",
      },
    ],
  };
  const columnInitial = {
    ...columns,
    name: selectedStore.value == 0 ? "GENERAL" : selectedStore.label,
  };
  const columnCompare = {
    ...columns,
    name:
      selectedStoreCompare.value == 0
        ? "GENERAL 2"
        : selectedStore.label == selectedStoreCompare.label
        ? selectedStoreCompare.label + " 2"
        : selectedStoreCompare.label,
  };
  const json = excelHelper.jsonToJson(
    [topCustomers, topCustomersCompare],
    [columnInitial, columnCompare]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(
    selectedStore,
    selectedStoreCompare,
    role,
    startDate,
    endDate
  );
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (
  selectedStore,
  selectedStoreCompare,
  role,
  startDate,
  endDate
) => {
  const storeName = selectedStore.label;
  const storeNameCompare = selectedStoreCompare.label;
  if (role == roles.SUPER_ADMIN || role == roles.ADMIN)
    return selectedStore.value == 0
      ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          "_reporte-general" +
          "-vs-" +
          (selectedStoreCompare.value == 0
            ? "general"
            : storeNameCompare.toLowerCase()) +
          "-" +
          "mejores-clientes_" +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          ".xlsx"
      : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
          "_reporte-mejores-clientes_" +
          storeName.toLowerCase() +
          "-vs-" +
          (selectedStoreCompare.value == 0
            ? "general"
            : storeNameCompare.toLowerCase()) +
          "_" +
          formatHelper.toDateYYMMDD(startDate._d) +
          "_" +
          formatHelper.toDateYYMMDD(endDate._d) +
          ".xlsx";
  else
    return (
      formatHelper.toDateYYMMDD(new Date().toUTCString()) +
      "_reporte-mejores-clientes_" +
      formatHelper.toDateYYMMDD(startDate._d) +
      "_" +
      formatHelper.toDateYYMMDD(endDate._d) +
      ".xlsx"
    );
};



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardTopCustomer/excel.js